var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 9.875C15.875 9.875 22.625 15 22.625 22.375C22.625 24.375 21 26 18.875 26H8.5C6.5 26 4.75 24.375 4.75 22.375C4.75 15 11.5 9.875 11.5 9.875C11.5 9.875 7 6 7 4.75C7 3.375 10 5.5 11.5 5.5C13.625 5.5 13.875 4 15.25 4C16.625 4 16.75 5.5 19 5.5C19.75 5.5 18.125 7.625 15.875 9.875Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.875H16.25C18 10 19.75 9.5 21.125 8.375M16.25 10C17.125 9.875 18 10.375 18.5 11.125",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 15.75C15.75 14.75 14.75 13.875 13.625 13.875C12.375 13.875 11.375 14.625 11.375 15.875C11.375 17.125 12.5 17.625 13.625 17.875C14.75 18.125 16 18.75 16 20C16 21.25 15 22 13.75 22M11.5 19.75C11.5 21 12.5 22 13.75 22M13.75 22V23.125M13.75 13.875V12.75",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValue);
export default __webpack_public_path__ + "static/media/icon-value.4bd510327318c39ead54d4d273534ec8.svg";
export { ForwardRef as ReactComponent };